var $ = require('jquery');

$.behaviors('.paymentTotal', function(container) {
  container = $(container);
  var components = container.find('.paymentTotal-component');
  var total = container.find('.paymentTotal-total');
  var removeLanguage = container.find('.removeLanguage');
  var removeLanguageFields = container.find('.removeLanguage-field');
  var languageSelectField = container.find("[data-type='amara-community-yt-languages']")

  function updateTotal() {
    var cost = total.data('baseCost');
    var template = total.data('template');
    components.each(function() {
      cost += componentCost($(this));
    });
    total.text(template.replace('{amount}', cost));
  }

  function updateRemoveLanguageFields() {
    var languageCount = removeLanguage.data('languageCount');
    var selectedLanguageCount = parseInt(languageSelectField.find('select').val()) + languageSelectField.data('baseUnits');
    if (selectedLanguageCount < languageCount) {
      removeLanguage.show();
      for(var i=0; i < languageCount; i++) {
        console.log(removeLanguageFields[i])
        if (i < languageCount - selectedLanguageCount) {
          $(removeLanguageFields[i]).parent().show();
        } else {
          $(removeLanguageFields[i]).parent().hide();
        }
      }
    } else {
      removeLanguage.hide();
      removeLanguageFields.each(function() {
        $(this).parent().hide();
      })
    }
  }

  function componentCost(component) {
    return parseInt(component.find('select').val()) * component.data('scale');
  }

  container.on('change', updateTotal);
  container.on('change', updateRemoveLanguageFields);
  updateTotal();
  updateRemoveLanguageFields();
});
